import { RouteObject } from 'react-router';
import { Outlet } from 'react-router';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { UsersPage } from './components/UsersPage';
import { UserProfilePage } from './components/UserProfilePage';
import { Permission } from '@/utils/roles';

export const userRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute requiredPermissions={[Permission.VIEW_USERS]}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <UsersPage /> },
      { path: ':userId', element: <UserProfilePage /> },
    ],
  },
];
